__turbopack_context__.v({
  "content": "tabs-module-scss-module__v5Nfma__content",
  "list": "tabs-module-scss-module__v5Nfma__list",
  "root": "tabs-module-scss-module__v5Nfma__root",
  "trigger": "tabs-module-scss-module__v5Nfma__trigger",
});
